import { Query } from '@/app/tracking/api';
import { StudentInfo } from './student-info'

export interface QueryStudentInfoTrackingQueryPayload {
}

export interface QueryStudentInfoTrackingQueryResult {
  studentInfo: StudentInfo
}

export const QueryStudentInfoTrackingQueryName = 'query-student-info' as const
export type QueryStudentInfoTrackingQuery =
      Query<typeof QueryStudentInfoTrackingQueryName, QueryStudentInfoTrackingQueryPayload, QueryStudentInfoTrackingQueryResult>
